// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
// import { IsNotEmpty } from "class-validator";
import { IsNotEmpty, IsPostalCode } from "class-validator";
// App
import { PreviousAddressDTO } from "Globals/Models/DTO/PreviousAddressDTO";

export class PreviousAddressModel extends ModelBase<PreviousAddressModel, PreviousAddressDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public personalDetailId: string = "";
    @IsNotEmpty({ message: "Address Line 1 is required" })
    @MobX.observable
    public addressLine1: string = "";

    @MobX.observable
    public addressLine2: string = "";

    @MobX.observable
    public addressLine3: string = "";

    @IsNotEmpty({ message: "City is required" })
    @MobX.observable
    public city: string = "";

    @IsNotEmpty({ message: "County is required" })
    @MobX.observable
    public county: string = "";

    @IsPostalCode("GB", { message: "Postcode is not a valid UK postcode" })
    @IsNotEmpty({ message: "Postcode is required" })
    @MobX.observable
    public postcode: string = "";

    @IsNotEmpty({ message: "Date from is required" })
    @MobX.observable
    public fromDate: Date = new Date();

    @IsNotEmpty({ message: "Date to is required" })
    @MobX.observable
    public toDate: Date = new Date();
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    @MobX.action
    public fromDto = (model: PreviousAddressDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.personalDetailId = model.personalDetailId;
            this.addressLine1 = model.addressLine1;
            this.addressLine2 = model.addressLine2;
            this.addressLine3 = model.addressLine3;
            this.city = model.city;
            this.county = model.county;
            this.postcode = model.postcode;
            this.fromDate = model.fromDate;
            this.toDate = model.toDate;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): PreviousAddressDTO => {
        let model: PreviousAddressDTO = {
            id: this.id,
            personalDetailId: this.personalDetailId,
            addressLine1: this.addressLine1,
            addressLine2: this.addressLine2,
            addressLine3: this.addressLine3,
            city: this.city,
            county: this.county,
            postcode: this.postcode,
            fromDate: this.fromDate,
            toDate: this.toDate,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };
    @MobX.action
    public resetModel = (): void => {
        this.id = "";
        this.personalDetailId = "";
        this.addressLine1 = "";
        this.addressLine2 = "";
        this.addressLine3 = "";
        this.city = "";
        this.county = "";
        this.postcode = "";
        this.fromDate = new Date();
        this.toDate = new Date();
        this.createdDate = null;
        this.isDeleted = false;
    };
}
